<template>
  <AppSelect
    ref="wrappedSelect"
    v-model="internalValue"
    :options="options"
    :select2-options="select2Options"
    :disabled="disabled"
    @input="onInput"
  />
</template>

<script>
// FIXME: For some reason mocking the component does not work for
// MemberProfileSelectCustom.spec.js
import AppSelect from '~/components/AppSelect.vue';
export default {
  name: 'MemberProfileSelectCustom',
  components: {
    AppSelect,
  },
  props: {
    field: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    select2Options: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalValue: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue;
    },
    internalValue(newValue) {
      this.$emit('input', newValue);
    },
  },
  mounted() {
    this.$nextTick(() => {
      $(this.$refs.wrappedSelect.$el)
        .find('select')
        .on('select2:open', () => {
          this.$nextTick(() => {
            this.addLinkToSelect();
          });
        });
    });
  },
  beforeDestroy() {
    $(this.$refs.wrappedSelect.$el).find('select').off('select2:open');
  },
  methods: {
    onInput(value) {
      this.internalValue = value;
    },
    addLinkToSelect() {
      const el = this.$refs.wrappedSelect.$el;
      const selectorID = el.querySelector('.select2-selection--single').getAttribute('aria-labelledby');

      if (selectorID) {
        const select2Dropdown = document.querySelector(`#${'select2-' + selectorID.split('-')[1] + '-results'}`);

        if (select2Dropdown && !select2Dropdown.parentNode.querySelector('.select2-edit-link')) {
          const editLink = document.createElement('div');

          editLink.className = 'select2-edit-link';
          editLink.textContent = 'Edit options';
          editLink.addEventListener('click', this.handleClick);

          select2Dropdown.parentNode.insertBefore(editLink, select2Dropdown);
        }
      }
    },
    handleClick() {
      this.$emit('open', this.field);
      $(this.$refs.wrappedSelect.$el).find('select').select2('close');
    },
  },
};
</script>
